import type { ReactNode } from "react";

type PreferenceLineProps = {
  title: string;
  value: string[];
  color?: string;
  titleEnd?: ReactNode;
};

export const PreferenceLine = ({ title, value, titleEnd }: PreferenceLineProps) => {
  return (
    <div className="flex w-full flex-row items-end justify-between border-0 border-b border-gray-200 py-4">
      <div className="flex flex-1 flex-col">
        <div className="flex flex-row items-center gap-2">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          {titleEnd}
        </div>
      </div>
      <div className="flex flex-1 flex-col">
        {value.map((value, index) => {
          return (
            <p className="text-base font-medium text-gray-700" key={index}>
              {value}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export const PreferenceLineColor = ({ title, value, color, titleEnd }: PreferenceLineProps) => {
  return (
    <div className="flex w-full flex-row items-end justify-between border-0 border-b border-gray-200 py-4">
      <div className="flex flex-1 flex-col">
        <div className="flex flex-row items-center gap-2">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          {titleEnd}
        </div>
      </div>
      <div className="flex flex-1 flex-row gap-2">
        <p className="text-base font-medium text-gray-700">{value[0]}</p>
        <div className={`h-[20px] w-[20px] rounded-sm`} style={{ backgroundColor: color }} />
      </div>
    </div>
  );
};
